import React from "react";

export const Mail = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31.304"
      height="23.722"
      viewBox="0 0 31.304 23.722"
    >
      <g id="mail" transform="translate(0 -62.009)">
        <path
          id="Path_225510"
          data-name="Path 225510"
          d="M25.573,62.009a5.741,5.741,0,0,0-5.558,4.331H2.29A2.278,2.278,0,0,0,.7,66.987h0l0,0A2.273,2.273,0,0,0,0,68.63V83.44a2.3,2.3,0,0,0,.724,1.671l0,0a2.282,2.282,0,0,0,1.563.617h21.6a2.282,2.282,0,0,0,1.559-.613l.009-.008a2.3,2.3,0,0,0,.722-1.669v-10a5.731,5.731,0,0,0-.611-11.43ZM2.29,67.563H19.845q0,.088,0,.177a5.7,5.7,0,0,0,.844,2.99l-7.194,6.8h-.8L2.157,67.571a1.082,1.082,0,0,1,.133-.008ZM1.223,68.63a1.078,1.078,0,0,1,.026-.235l8.565,8.1L1.27,83.756a1.073,1.073,0,0,1-.047-.316ZM23.894,84.508H2.275l8.432-7.17,1.322,1.249a.611.611,0,0,0,.42.167h1.286a.612.612,0,0,0,.42-.167l1.322-1.249,8.433,7.171Zm1.067-1.067a1.072,1.072,0,0,1-.047.316l-8.544-7.265L21.437,71.7a5.719,5.719,0,0,0,3.525,1.736Zm.611-11.192a4.508,4.508,0,1,1,4.508-4.508A4.513,4.513,0,0,1,25.573,72.248Z"
          transform="translate(0 0)"
          fill="#2e2e2e"
        />
        <circle
          id="Ellipse_135"
          data-name="Ellipse 135"
          cx="5"
          cy="5"
          r="5"
          transform="translate(21 62.658)"
          fill="#2e2e2e"
        />
      </g>
    </svg>
  );
};
